interface TrackResetFiltersProps {
  location: 'mentors' | 'dashboard';
}

export const segment = window.analytics;

export const track = (event: string, properties?: Record<string, any>) => {
  segment.track(event, properties);
};

export const trackResetFilters = (props: TrackResetFiltersProps) => {
  track('Filters Reset', props);
};
